// extracted by mini-css-extract-plugin
module.exports = {"button":"ImportStatusButton_button__WhV_e","icon":"ImportStatusButton_icon__l4EXi","rotate-forever":"ImportStatusButton_rotate-forever__r7_oF"};